import { useMemo } from 'react';

import { useTextStyle } from '@webapp/common/components/custom-styles';

import { selectErrorText } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

import css from './survey-error.css';

export const SurveyError: VFC = () => {
    const errorText = useStateSelector(selectErrorText);
    const { questionGap } = useTextStyle();
    const style = useMemo(
        () => ({
            rowGap: questionGap,
            marginBottom: questionGap,
        }),
        [questionGap],
    );

    return (
        <div className={css.surveyError} style={style}>
            <div>{errorText}</div>
        </div>
    );
};
